<template>
	<div id="app">
		<el-container class="container">
			<el-backtop :bottom="200"></el-backtop>
			<el-header class="headerBox" v-show="showAi">
				<headBox @loginBoxShow="loginBoxShow" @loginOut="loginOut" :loginInfo="loginInfo"></headBox>
			</el-header>
			<el-main class="mainBox" @loginOut="loginOut" >
				<router-view ref="mainBox"></router-view>
			</el-main>
			<el-footer class="footerBox" v-show="showAi">
				<footerBox></footerBox>
			</el-footer>
		</el-container>

		<!-- <el-dialog :visible.sync="dialogVisible" 
			width="400px" 
			:before-close="handleClose" 
			:close-on-click-modal="true"
			title="欢迎登录宠医客"
			:destroy-on-close="true"
			:show-close="showClose"
			>
			<div class="changeForm" >
				<el-form ref="form" :model="form" label-width="0">
					<el-form-item >
						<el-input type="number" v-model="form.phone" placeholder="请输入账号" :clearable="true"></el-input>
					</el-form-item>
					<el-form-item>
						<el-input type="password" v-model="form.password" placeholder="请输入密码" :show-password="true"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button style="width: 80%; background-color: #206daf;margin: 0 10%;" type="primary" round @click="onSubmit">登录</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog> -->

		<el-dialog :visible.sync="dialogVisible" 
			:before-close="handleClose" 
			:close-on-click-modal="false"
			:destroy-on-close="true"
			:show-close="showClose"
			class="loginBoxDialog"
			>
			<div class="loginBigBox">
				<div class="loginBox">
					<div class="imgBox">
						<img class="loginBgi" :style="chanegIndex==1?'z-index: 10;':'z-index: 1;'" src="../src/assets/images/loginBgi.png" alt="">
						<img class="loginBgi" :style="chanegIndex==2?'z-index: 10;':'z-index: 1;'" src="../src/assets/images/loginBgi2.png" alt="">
					</div>
					<div class="changeBox">
						<div class="changeBtn" :style="chanegIndex==2?'color:#206daf;':''" @click="chanegIndex = 2">短信验证码登录</div>
						<div class="changeBtn" :style="chanegIndex==1?'color:#206daf;':''" @click="chanegIndex = 1">账号密码登录</div>
					</div>
					<div class="changeForm" v-show="chanegIndex == 1">
						<el-form ref="form" :model="form" label-width="0">
							<el-form-item >
								<el-input type="number" v-model="form.phone" placeholder="请输入账号" :clearable="true"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input type="password" v-model="form.password" placeholder="请输入密码" :show-password="true"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button style="width: 80%; background-color: #206daf;margin: 0 10%;" type="primary" round @click="onSubmit">登录</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="changeForm" v-show="chanegIndex == 2">
						<el-form ref="form" :model="form" label-width="0">
							<el-form-item >
								<el-input type="number" v-model="form.phone" placeholder="请输入手机号" :clearable="true"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input style="width: 200px;" type="number" v-model="form.verificationcode" placeholder="请输入验证码" :clearable="true"></el-input>
								<span class="codeBtn" v-show="djs" @click="senderShortMessageCode()">获取验证码</span>
								<span class="codeBtn" v-show="!djs" >{{ count }}秒</span>
							</el-form-item>
							<el-form-item>
								<el-button style="width: 80%; background-color: #206daf;margin: 0 10%;" type="primary" round @click="onSubmit">登录</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="toastMsg">
						未注册过的手机号，我们将自动帮您注册账号
						<br>注册即同意<span>《用户协议》</span>和<span>《隐私协议》</span>
					</div>
					<img class="closeLoginBox" @click="dialogVisible = false" src="./assets/images/uploadfileBtn.png" alt="">
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import wxlogin from './views/wxlogin.vue'
import headBox from './views/header.vue'
import footerBox from './views/footer.vue'
import hex_md5 from "./assets/js/md5"
export default {
	name: 'App',
	components: {
		wxlogin,
		headBox,
		footerBox
	},
	// 监听,当路由发生变化的时候执行
	data() {
		return {
			// 登录框显示
			dialogVisible: false,
			chanegIndex: 2,
			// 登录框关闭按钮
			showClose: true,
			// 用户信息
			loginInfo: {
				name: "请登录",
            	HeadPortrait: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
				isLogin: false,
				isVIP: false
			},
			// 登录参数
			form: {
				// phone: "15551297670",
				// password: "xc001120",
				phone: "",
				password: "",
				verificationcode: ""
			},
			// 在Ai页隐藏头部底部
			showAi: true,
			// 短信倒计时
			count:60,
			djs: true,
			// 统计时长的秒数
			durationNum: 0,
			// 加秒数的方法
			durationFun: {}
		}
	},
	created() {
		const that = this
		that.forLoginShow()
		// 统计时长
		// that.useRecord(0)
		// 已经有登录信息则直接取
		if(that.Cookies.get("loginInfo")){
			that.loginInfo = JSON.parse(that.Cookies.get("loginInfo"))
		}
		// AI页面隐藏头部底部
		if(this.$route.fullPath.indexOf('/webAi') > -1 || this.$route.fullPath.indexOf('/webAI') > -1){
			this.showAi = false
		}else {
			this.showAi = true
		}
		if (this.$route.query.code) {
			this.loginForWX()
		}
	},
	watch:{
		'$route'(to, from) {
			// 路由变化时执行的代码
			if(to.path.indexOf('/webAi') > -1|| to.path.indexOf('/webAI') > -1){
				this.showAi = false
			}else {
				this.showAi = true
			}
			this.getUserInfo()
		},
		dialogVisible(){
			this.form = {
				phone: "",
				password: "",
				verificationcode: ""
			}
		}
	},
	methods: {
		// 获取用户信息
        getUserInfo(){
            const that = this
            var data = {
                type: 'getUserInfo',
            }
            this.get("/3/mobileHandler", data, 1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                }
            })
        },
		forLoginShow(){
			if(this.Cookies.get('loginShow')){
				this.loginInfo = {
					HeadPortrait: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
					name: "请登录",
					isLogin: false
				}
				this.Cookies.remove("loginInfo")
				this.Cookies.remove("token")
				this.showClose = false
				this.loginBoxShow(1)
            	this.Cookies.remove("loginShow")
			} 
			setTimeout(() => {
				this.forLoginShow()
			}, 500);
		},
		handleClick(tab, event) {
			console.log(tab, event);
		},
		APPshowLeaveConfirmation(event) {
			this.useRecord(1)
			return message;
		},
		// 统计时长
		useRecord(useType){
			const that = this
			var url = 'https://appinterface.chongyike.com/webhttp/mobileHandler?type=useRecord&useType='+ useType +'&duration=1' + that.getConfigText()
				// url = 'http://192.168.18.121:82/webhttp/mobileHandler?type=useRecord&useType='+ useType +'&duration=1' + that.getConfigText()
			fetch( url, {
				method: 'GET',
				headers: {
					Authorization:  this.Cookies.get('token')!='undefined'? 'Bearer ' + this.Cookies.get('token'):''
				},
				keepalive: true // 关键！确保请求在页面卸载后也能发出
			});
			if(useType == 0){
				that.durationFun = setInterval(()=>{
					that.durationNum += 1
				},1000)
			}else {
				clearInterval(that.durationFun)
			}
		},
		getConfigText(){
			const that = this
			// 获取当前时间
			var time = (new Date()).getTime();
			var data = {
				// 接口来源 安卓/IOS/WEB
				client: "WEB",
				// 版本号
				device: "",
				// 时间戳
				requestTime: time,
				// 版本号
				versionCode: 251,
			}
			if(this.Cookies.get('device')){
				data.device = this.Cookies.get('device')
			}else {
				var lsnms = num();
				var strs = time + "" + lsnms;
				var device = hex_md5(strs).toUpperCase();
				this.Cookies.set('device', device, {  expires: 7 })
				data.device = device
			}
			data.sign = that.serSign(data)
			var texts = ""
			for (let key in data) {
				if (data.hasOwnProperty(key)) {
					texts +=  "&" +  key + "=" + data[key]
				}
			}
			return texts
		},
		serSign(data){
			var text = ""
			for (let key in data) {
				text = text + key + '=' + data[key] + "&"
			}
			return hex_md5(text + 'key=huiyichongyike')
		},
		// 点击登录
		onSubmit() {
			const that = this
			if(that.form.phone.trim() == "" ){
				that.$message({
					showClose: true,
					message: "请输入账号",
					type: 'error'
				});
				return false
			}
			if(that.form.password.trim() == "" && that.chanegIndex == 1){
				that.$message({
					showClose: true,
					message: "请输入密码",
					type: 'error'
				});
				return false
			}
			if(that.form.verificationcode.trim() == "" && that.chanegIndex == 2){
				that.$message({
					showClose: true,
					message: "请输入验证码",
					type: 'error'
				});
				return false
			}
			that.loginForWeb()
			return false
            var data = { 
                type: 'loginForPassword',
                phone: that.form.phone,
                password: this.hex_md5(that.form.password)
            }
            this.get("/4/login",data).then((res)=>{
                if(res.data.code == "success"){
                    var result = res.data.result
					var data = {
						HeadPortrait: "https://case.chongyike.com" + result.HeadPortrait,
						name: result.name,
						No: result.No,
						isLogin: true,
						IMID: result.IMID,
						isVIP: that.timePK(result.vipTime),
					}
					that.loginInfo = data
					that.Cookies.set('loginInfo', JSON.stringify(data), {  expires: 7 });
					that.Cookies.set('token', that.decrypt(res.data.message), {  expires: 7 });
					that.loginBoxShow(0)
					that.$message({
						showClose: true,
						message: "登录成功",
						type: 'success'
					});
					setTimeout(() => {
						// that.$router.go(0)
                		window.location.reload()
					}, 500);
                }else {
					this.$message({
						showClose: true,
						message: res.data.message,
						type: 'warning'
					});
                }
            })
		},
		// 新版登录
		loginForWeb(){
			const that = this
			var text = {
                phone: that.form.phone,
			}
			if(that.chanegIndex == 1){
				text.password = this.hex_md5(that.form.password)
			}else {
				text.verificationCode = that.form.verificationcode
			}
            var data = { 
                type: 'loginForWeb',
				text: that.encrypt(JSON.stringify(text))
            }
            this.get("/4/login",data, 1).then((res)=>{
                if(res.data.code == "success"){
                    var result = JSON.parse(that.decrypt(res.data.result))
					var data = {
						HeadPortrait: "https://case.chongyike.com" + result.HeadPortrait,
						name: result.name,
						No: result.No,
						isLogin: true,
						IMID: result.IMID,
						phone: result.phone,
						isVIP: that.timePK(result.vipTime),
					}
					that.loginInfo = data
					that.Cookies.set('loginInfo', JSON.stringify(data), {  expires: 7 });
					that.Cookies.set('token', that.decrypt(res.data.message), {  expires: 7 });
					that.loginBoxShow(0)
					that.$message({
						showClose: true,
						message: "登录成功",
						type: 'success'
					});
					setTimeout(() => {
						// if(that.$route.path == '/webAi'){
	                		window.location.reload()
						// }
					}, 500);
                }else {
					this.$message({
						showClose: true,
						message: res.data.message,
						type: 'warning'
					});
                }
            })
		},
		// 获取验证码
		senderShortMessageCode(){
			const that = this
            var data = { 
                type: 'senderShortMessageCode',
				phone: that.form.phone,
				shortMsgType: 2,
            }
            that.get("/webhttp/mobileHandler",data, 1).then((res)=>{
                if(res.data.code == "success"){
					that.daoshu()
					this.$message({
						showClose: true,
						message: res.data.message,
						type: 'success'
					});
                }else {
					this.$message({
						showClose: true,
						message: res.data.message,
						type: 'warning'
					});
                }
            })
		},
		// 倒计时显示
		daoshu() {
			const that = this
			that.count = 60
			that.djs = false
			that.setdaojishi = setInterval(() => {
				that.count--
				if (that.count == 0) {
					that.djs = true
					clearInterval(that.setdaojishi)
				}
			}, 1000)
		},
        // 登出
        loginOut(){
            const that = this
            // 重置默认信息
            that.loginInfo = {
                HeadPortrait: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
                name: "请登录",
                isLogin: false
            }
            that.Cookies.remove("loginInfo")
            that.Cookies.remove("token")
            that.$message({
                message: "退出成功",
                type: 'success'
            });
            // 跳回首页
            if(this.$route.path != "/home"){
                that.$router.push({
                    path: "/home",
                })
            }
        },
		// 控制登录框显示
		loginBoxShow(type){
			const that = this
			if(type == 0){
				that.dialogVisible = false
			}else if(type == 1){
				that.dialogVisible = true
			}
		},
		// 关闭登录框
		handleClose(done) {
			done();
		},
		// 日期对比
		timePK(time){
			const that = this
			const date1 = new Date().getTime();
			const date2 = new Date(time).getTime();
			// true日期未到  false日期已过
			return date1 < date2
		},
	}
}
</script>

<style lang="scss">
* {
}
#app {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0;
	margin: 0;
	overflow-x: hidden;
	// overflow-y: scroll;

	.container {
		width: 100vw;
	}

	.headerBox {
		width: 1170px;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		height: 80px !important;
	}

	.footerBox {
		width: 100%;
		height: auto !important;
		background: #F9FAFF;

	}

	.mainBox {
		padding: 0;
	}
	.content {
		width: 1170px;
		margin: 0 auto;
	}
 
	// 输入框不显示加减按钮
	input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}
	input[type="number"]{
		-moz-appearance: textfield;
	}
}
.el-header {
	padding: 0 ;
}
.loginBoxDialog {
	.el-dialog {
		box-shadow: none;
		border: none;
		background-color: rgba(0,0,0,0);
	}
}
.loginBigBox {
	position: fixed;
	left: 0;
	top: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba($color: #000, $alpha: .6);
	display: flex;
	align-items: center;
	justify-content: center;
	.loginBox {
		position: relative;
		width: 400px;
		top: -100px;
		.changeBox {
			display: flex;
			align-items: center;
			margin-bottom: 15px;
			.changeBtn {
				width: 50%;
				height: 20px;
				padding: 10px 0 15px;
				padding-left: 50px;
				cursor: pointer;
				&:hover {
					color:#6eb2ee;
				}
				&:nth-child(2){
					text-align: right;
					padding-right: 50px;
				}
			}
		}
		.el-input--suffix {
			width: 80%;
			margin: 0 10%;
		}
		.codeBtn {
			position: absolute;
			right: 40px;
			color: #206daf;
			text-align: center;
			width: 102px;
			box-sizing: border-box;
			padding: 0 15px;
			border: 1px solid #206daf;
			border-radius: 5px;
			font-size: 12px;
			cursor: pointer;
			// &::before {
			// 	content: '';
			// 	position: absolute;
			// 	left: -20px;
			// 	top: 10px;
			// 	width: 1px;
			// 	height: 20px;
			// 	background-color: #d3d3d3;
			// }
		}
		.toastMsg {
			width: 100%;
			padding-top: 20px;
			text-align: center;
			color: #bfbfbf;
			font-size: 13px;
			span {
				color: #206daf;
				cursor: pointer;
			}
		}
		.imgBox {
			position: absolute;
			width: 100%;
			left: 0px;
			top: -15px;
			z-index: -1;
			.loginBgi {
				position: absolute;
				width: 100%;	
				left: 0;
				top: 0;
			}
		}
	}

	.closeLoginBox {
		position: absolute;
		right: -40px;
		top:  -40px;
		width: 25px;
		height: 25px;
		transform: rotate(45deg);
		cursor: pointer;
	}
}

// 修改滚动条样式
::-webkit-scrollbar {
	width: 15px; /* 垂直滚动条的宽度 */
	height: 4px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1; /* 滚动条轨道的背景颜色 */
  border-radius: 10px; /* 滚动条轨道的圆角 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #888; /* 滚动条滑块的颜色 */
  border-radius: 10px; /* 滚动条滑块的圆角 */
}

/* 鼠标悬停在滑块上时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 鼠标悬停时的颜色 */
}


// 倒计时模块
.con {
	justify-content: start !important;
	text-align: left !important;
}

.default {
	background-image: url(./assets/images/default.jpg);
	background-size: 130%;
	background-position: center center;
	background-repeat: no-repeat;
}

.content {
    // border-top: 1px solid #ccc;
    padding: 20px 0;
}
.titlelabel {
	display: flex;
	-ms-align-items: center;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 1.25rem;

	.title {
		color: #444;
		font-weight: 600;
		font-size: 1.6rem;
		margin-right: 20px;
	}

	.moreclass {
		font-size: 14px;
		color: #666666;
		cursor: pointer;
	}
}

.searchContent  {
	.el-tabs__item {
		font-size: 16px;
	}
	.el-tabs__nav-wrap::after {
		background-color: #fff;
	}
}


.el-carousel__container {
	height: 17vw !important;

}

.prism-player {
	// height: 500px !important;
}


li {
	padding-left: 20px;
	list-style: none;
	line-height: 30px;
}
hr {
    margin: 10px 0 !important;
}


h2,h3 {
    margin-top: 20px;
	margin-bottom: 5px;
}

table{
  border: 1px solid #ccc;
  border-spacing: 0;
}
table td, th{
  border: 1px solid #ccc;
  padding: 5px 5px;
}
</style>
